export default __webpack_public_path__ + "static/media/Sage's Boots of the Bloody Stone.3722208c.jpg";